import type { DrawingTool } from '@trimble/geospatial';
import {
  CapabilityCategory,
  SingleCapabilityBase,
} from '@trimble/web3d-capabilities';
import type { Web3DViewer } from '@technology/web3d';
import type { Accessor } from 'solid-js';

import type { FeatureExtractionController } from './feature-extraction-controller';

export class CadEditingCapability extends SingleCapabilityBase {
  public override readonly category = CapabilityCategory.Markup;

  constructor(
    viewer: Web3DViewer,
    private readonly getCadEditingSession: Accessor<
      FeatureExtractionController | undefined
    >,
    private readonly clearDesiredDrawingTool?: () => void
  ) {
    super(viewer);
  }

  public toggleTool(tool: DrawingTool): void {
    const session = this.getCadEditingSession();
    if (!session) {
      return;
    }

    if (!this.isActive() && !this.activate()) {
      return;
    }
    session.toggleTool(tool);
  }

  public override deactivate(): boolean {
    const session = this.getCadEditingSession();
    session?.cancelActiveTool();
    if (session) {
      this.clearDesiredDrawingTool?.();
    }
    return super.deactivate();
  }

  public override cleanup(): Promise<void> {
    this.getCadEditingSession()?.cancelActiveTool();
    return Promise.resolve();
  }
}
